import * as colors from "material-ui/styles/colors";

export default [
  colors.red400,
  colors.red500,
  colors.red600,
  colors.red700,
  colors.red800,
  colors.red900,

  colors.pink300,
  colors.pink400,
  colors.pink500,
  colors.pink600,
  colors.pink700,
  colors.pink800,
  colors.pink900,

  colors.purple300,
  colors.purple400,
  colors.purple500,
  colors.purple600,
  colors.purple700,
  colors.purple800,
  colors.purple900,

  colors.deepPurple300,
  colors.deepPurple400,
  colors.deepPurple500,
  colors.deepPurple600,
  colors.deepPurple700,
  colors.deepPurple800,
  colors.deepPurple900,

  colors.indigo300,
  colors.indigo400,
  colors.indigo500,
  colors.indigo600,
  colors.indigo700,
  colors.indigo800,
  colors.indigo900,

  colors.blue500,
  colors.blue600,
  colors.blue700,
  colors.blue800,
  colors.blue900,

  colors.cyan700,
  colors.cyan800,
  colors.cyan900,

  colors.teal400,
  colors.teal500,
  colors.teal600,
  colors.teal700,
  colors.teal800,
  colors.teal900,

  colors.green600,
  colors.green700,
  colors.green800,
  colors.green900,

  colors.orange800,
  colors.orange900,

  colors.deepOrange500,
  colors.deepOrange600,
  colors.deepOrange700,
  colors.deepOrange800,
  colors.deepOrange900,

  colors.blueGrey400,
  colors.blueGrey500,
  colors.blueGrey600,
  colors.blueGrey700,
  colors.blueGrey800,
  colors.blueGrey900,
];
